import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, ref } from "vue";
import { debounce, Toast, timeStampToTime } from "@/utils/index";
import { modifyExpiresDate } from "@/request/view/prototypeManagement";


export default /*#__PURE__*/_defineComponent({
  __name: 'extension',
  emits: ['handleUpdateTable'],
  setup(__props, { expose: __expose, emit: __emit }) {

const modalConfig = reactive({
  visible: false,
  title: null,
});

const formState = reactive({
  expiresDate: null,
  id: null,
});

const rules = {
  expiresDate: [
    {
      required: true,
      message: "请选择到期时间",
      trigger: "blur",
      type: "any",
    },
  ],
};

const formRef = ref();

const emit = __emit;

const handleOk = debounce(() => {
  formState.expiresDate = timeStampToTime(formState.expiresDate, 'upload');
  modifyExpiresDate(formState)
    .then((res) => {
      console.log(res, 'rws');
      const { code, data, message } = res;
      const type = code === 200 ? "success" : "warning";
      Toast(type, message, 3);

      if (code === 200) {
        resetForm();
        emit('handleUpdateTable');
      }
    })
    .catch((err) => {});
});

const disabledDate = (current) => {
  return current && current < new Date(formState.expiresDate);
};

const resetForm = () => {
  formState.expiresDate = null;
  formState.id = null;
  formRef.value.clearValidate();
  modalConfig.visible = false;
};

const handleCancel = () => {
  resetForm();
};

const showModal = (data) => {
  const { expiresDate, id } = data;
  formState.expiresDate = expiresDate;
  formState.id = id;
  modalConfig.title = "样机延期";
  modalConfig.visible = true;
};

__expose({
  showModal,
});

return (_ctx: any,_cache: any) => {
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: modalConfig.visible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((modalConfig.visible) = $event)),
    title: modalConfig.title,
    onOk: _unref(handleOk),
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: formState,
        ref_key: "formRef",
        ref: formRef,
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "到期时间" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_date_picker, {
                "disabled-date": disabledDate,
                value: formState.expiresDate,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.expiresDate) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "title", "onOk"]))
}
}

})